import React, { useEffect } from "react";
import { connect } from "react-redux";
import DashboardHeader from "./header";
import SalesDataTable from "./datatable";

const SaleDashboard = (props) => {
    useEffect(() => {}, []);

    return (
        <div>
            <DashboardHeader />
            <SalesDataTable />
        </div>
    );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SaleDashboard);
